import { Checkbox } from "@Tmp/Fields";
import Search from "@Tmp/Search";
import { TagProps, TagsProps } from "../ProductList.types";
import clsx from "clsx";
import * as React from "react";
import SelectedTags from "./SelectedTags";

const Tags: React.FC<TagsProps> = ({
    container: { className: containerClassName, ...container } = {},
    style = {},
    ...props
}) => {
    const [tagsSearch, setTagsSearch] = React.useState("");

    const value = tagsSearch.toLowerCase().replace(/\s+/g, "");
    const tags = props.tags.filter(
        (tag) => tag.name.toLowerCase().replace(/\s+/g, "").indexOf(value) > -1
    );

    return (
        <div
            className={clsx(containerClassName, "tmp-product-list__toolbar__filter-container")}
            style={style}
            {...container}
        >
            <div className="tmp-product-list__tags__header">
                <div className="tmp-product-list__tags__header-main-row">
                    <div className="tmp-product-list__tags__header-row">
                        <div
                            className="tmp-product-list__tags__back"
                            onClick={() => {
                                props.setCurrentCategoryId(null);
                            }}
                        >
                            <i className="fas fa-angle-left fa-2x"></i>
                        </div>
                        <h4>{props.categoryName}</h4>
                    </div>
                    {props.disableSearch ? null : (
                        <Search
                            search={tagsSearch}
                            setSearch={setTagsSearch}
                            placeholder="Søg.."
                            classes={{
                                container: ["tmp-product-list__tags__search-container"],
                                search: ["tmp-product-list__tags__search"],
                            }}
                        />
                    )}
                </div>
                <SelectedTags
                    resetFiltersText={
                        props.settings.filters_reset_text ? props.settings.filters_reset_text : ""
                    }
                    tags_raw={props.tags_raw}
                    selected_tags={props.selected_tags.filter((tag) =>
                        props.settings.main_tags.includes(tag) ? false : true
                    )}
                    onTagChange={props.onTagChange}
                    resetFilters={props.resetFilters}
                />
            </div>
            <div className="tmp-product-list__tags">
                {tags
                    .sort((a, b) => {
                        if (a.name > b.name) {
                            return 1;
                        }
                        if (a.name < b.name) {
                            return -1;
                        }
                        return 0;
                    })
                    .map((tag) => (
                        <Tag
                            key={tag.id}
                            tag={tag}
                            selected_tags={props.selected_tags}
                            onTagChange={props.onTagChange}
                        />
                    ))}
            </div>
        </div>
    );
};

const Tag: React.FC<TagProps> = (props) => {
    return (
        <Checkbox
            checked={props.selected_tags.includes(props.tag.id) ? true : false}
            onChange={() => {
                props.onTagChange(props.tag);
            }}
            classes={{
                container: "tmp-product-list__tags__item",
            }}
            label={props.tag.name}
        />
    );
};

export default Tags;
